angular.module('account').config(['AppRoutesProvider', '$stateProvider',
    function (AppRoutesProvider, $stateProvider) {
        'use strict';

        var appRoutes = {
            'createaccountlayout': {
                state: 'createaccountlayout',
                route: '/createaccountlayout',
                portalSettings: {
                    hideHeader: false,
                    hideToolbar: true
                }
            },
            'emailoptoutlayout': {
                state: 'emailoptoutlayout',
                route: '/emailoptoutlayout',
                portalSettings: {
                    hideHeader: false,
                    hideToolbar: true
                }
            },
            'changepassword': {
                state: 'createaccountlayout.changepassword',
                route: '/changepassword/',
                portalSettings: {
                    hideHeader: false,
                    hideToolbar: true
                }
            },
            'emailoptout': {
                state: 'emailoptoutlayout.emailoptout',
                route: '/emailoptout/:accessCode',
                portalSettings: {
                    hideHeader: false,
                    hideToolbar: true
                }
            },
            'forgotpassword': {
                state: 'createaccountlayout.forgotpassword',
                route: '/forgotpassword/',
                portalSettings: {
                    hideHeader: false,
                    hideToolbar: true
                }
            },
            'accountActivationRequest': {
                state: 'createaccountlayout.accountActivationRequest',
                route: '/accountActivationRequest',
                portalSettings: {
                    hideHeader: false,
                    hideToolbar: true
                }
            },
            'accountActivation': {
                state: 'createaccountlayout.accountActivation',
                route: '/accountActivation/:webRegistrationId',
                portalSettings: {
                    hideHeader: false,
                    hideToolbar: true
                }
            },
            'accountvalidation': {
                state: 'createaccountlayout.accountvalidation',
                route: '/accountvalidation',
                portalSettings: {
                    hideHeader: false,
                    hideToolbar: true
                }
            },
            'accountsetup': {
                state: 'createaccountlayout.accountsetup',
                route: '/accountsetup',
                portalSettings: {
                    hideHeader: false,
                    hideToolbar: true
                }
            },
            'aprimaconditions': {
                state: 'createaccountlayout.aprimaconditions',
                route: '/aprimaconditions',
                portalSettings: {
                    hideHeader: false,
                    hideToolbar: true
                }
            },
            'loginconsent': {
                state: 'createaccountlayout.loginconsent',
                route: '/loginconsent',
                portalSettings: {
                    hideToolbar: true,
                    toolbarItem: 'consent'
                }
            },
        };

        AppRoutesProvider.setupAppRoutes(appRoutes);

        $stateProvider
            .state(appRoutes.createaccountlayout.state, {
                url: appRoutes.createaccountlayout.route,
                templateUrl: '/account/views/createaccountlayout.html',
                controller: 'CreateAccountCtrl',
                description: '/CreateAccount',
                resolve: {
                    $title: function (gettextCatalog) { return gettextCatalog.getString('Complete your account'); }
                }
            })
            .state(appRoutes.emailoptoutlayout.state, { // email opt out layout
                url: appRoutes.emailoptoutlayout.route,
                templateUrl: '/account/views/emailoptoutlayout.html',
                controller: 'EmailOptOutLayoutCtrl',
                description: '/EmailOptOutLayout',
                resolve: {
                    $title: function (gettextCatalog) { return gettextCatalog.getString('Email Opt Out'); }
                }
            })
            .state(appRoutes.changepassword.state, {
                url: appRoutes.changepassword.route,
                templateUrl: '/account/views/changepassword.html',
                controller: 'ChangePasswordCtrl',
                description: '/ChangePassword'
            })
            .state(appRoutes.emailoptout.state, { // emailoptout
                url: appRoutes.emailoptout.route,
                templateUrl: '/account/views/emailoptout.html',
                controller: 'EmailOptOutCtrl',
                description: '/EmailOptOut'
            })
            .state(appRoutes.forgotpassword.state, {
                url: appRoutes.forgotpassword.route,
                templateUrl: '/account/views/forgotpassword.html',
                controller: 'ForgotPasswordCtrl',
                description: '/ChangePassword',
                resolve: {
                    $title: function (gettextCatalog) { return gettextCatalog.getString('Forgot Password'); }
                }
            })
            .state(appRoutes.accountActivationRequest.state, {
                url: appRoutes.accountActivationRequest.route,
                templateUrl: '/account/views/accountActivationRequest.html',
                controller: 'AccountActivationRequestCtrl',
                description: '/AccountActivationRequest'
            })
            .state(appRoutes.accountActivation.state, {
                url: appRoutes.accountActivation.route,
                templateUrl: '/account/views/accountActivation.html',
                controller: 'AccountActivationCtrl',
                description: '/AccountActivation'
            })
            .state(appRoutes.accountvalidation.state, {
                url: appRoutes.accountvalidation.route,
                templateUrl: '/account/views/accountvalidation.html',
                controller: 'AccountValidationCtrl',
                description: '/AccountValidation'
            })
            .state(appRoutes.accountsetup.state, {
                url: appRoutes.accountsetup.route,
                templateUrl: '/account/views/accountsetup.html',
                controller: 'AccountSetupCtrl',
                description: '/AccountSetup'
            })
            .state(appRoutes.aprimaconditions.state, {
            url: appRoutes.aprimaconditions.route,
                templateUrl: '/account/views/aprimaconditions.html',
                controller: 'AprimaConditionsCtrl',
                description: '/AprimaConditions'
            })
            .state(appRoutes.loginconsent.state, {
                url: appRoutes.loginconsent.route,
                templateUrl: '/account/views/loginconsent.html',
                description: '/LoginConsent',
                controller: 'LoginConsentCtrl',
                resolve: {
                    $title: function (gettextCatalog) { return gettextCatalog.getString('Aprima Consent'); }
                }
            });
            
    }]);